module.exports = __webpack_public_path__ + "media/components/web/layout/xavin-7df26495b8744f426905b0f02598b28d.svg";